import React from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';

import { getPopupContent } from './utils';
import { usePopupContext } from '../contexts/PopupContext';
import { useAppContext } from '../contexts/AppContext';

import { POPUP_NAMES } from '../../constants/popups';

import { linkOnClickHandler } from '../navigation/navigation';

const { G5_ORF_PM_FORM1_ALT_TEXT_POPUP } = POPUP_NAMES;

const OrfG5PMForm1AltTextPopup = () => {
    const {
        header,
        message,
        cancelButtonText,
        printedKitButtonText,
        downloadedPDFButtonText,
    } = getPopupContent(G5_ORF_PM_FORM1_ALT_TEXT_POPUP);

    const { checkAndGetSessionStatus } = useAppContext();

    const {
        params: { orfF1PDFAssessLink, orfF1KitAssessLink },
        actions: { hideOrfG5PMForm1AltTextPopup },
    } = usePopupContext();

    const onCancel = () => {
        hideOrfG5PMForm1AltTextPopup();
    };
    const onPrintedKit = linkOnClickHandler(orfF1KitAssessLink, checkAndGetSessionStatus);

    const onDownloadedPDF = linkOnClickHandler(orfF1PDFAssessLink, checkAndGetSessionStatus);

    return (
        <Popup
            header={header}
            message={message}
            cssClass="g5-orf-pm-form1-popup"
            buttons={[
                <Button key="cancel-button" onClick={onCancel}>
                    {cancelButtonText}
                </Button>,
                <Button key="downloaded-pdf-button" onClick={onDownloadedPDF}>
                    {downloadedPDFButtonText}
                </Button>,
                <Button key="printed-kit-button" onClick={onPrintedKit}>
                    {printedKitButtonText}
                </Button>,
            ]}
        />
    );
};

export default OrfG5PMForm1AltTextPopup;
